// CORE (da inserire nel bundle principale)
import _scrollTo from "./_core/_scrollto.controls.ts";
import MediaQueries from "./_utils/_mediaQueries.ts";
_scrollTo.init();

// FORMS
const forms = document.getElementsByTagName("form");
if (forms && forms.length > 0) {
    import("./_formValidation/_validation.bootstrapper.ts").then(({ default: _validationBootstrapper }) => {
        _validationBootstrapper.init(forms);
    });
}
const formIscrizione = document.querySelector<HTMLFormElement>("#form-iscrizione form");
if (formIscrizione) {
    import("./_formValidation/_formIscrizione.ts").then(({ default: _formIscrizione }) => {
        _formIscrizione.init(formIscrizione);
    });
}

// LIBRARIES
const swiper = document.querySelector(".swiper");
if (swiper) {
    import("./_engine/_swiper.controls.ts").then(({ default: _swiperControls }) => {
        _swiperControls.init();
    });
}

// ENGINE
const loadMore = document.querySelectorAll<HTMLButtonElement>("button[load-more]");
if(loadMore.length > 0) {
    import('./_engine/_loadMore.controls.ts').then(({default: _loadMore}) => {
        loadMore.forEach(button => {
            _loadMore.init(button);
        })
    });
}

const filteredElement = document.querySelector(".filtered")
if(filteredElement) {
    const filter = document.getElementById("filter");
    if(filter)
        import('./_engine/_filter.setter.ts').then(({default: _filterSetter}) => {
            _filterSetter.init(filter);
        });
}

const lightbox = document.querySelector("[data-fslightbox]");
if (lightbox) {
    // @ts-ignore
    import("fslightbox");
}

// BLOCKS
const accordions = document.querySelectorAll(".accordion-container");
if (accordions.length > 0) {
    import("./_blocks/_accordion.ts").then(({ default: _accordion }) => {
        _accordion.init(accordions);
    });
}

const puntoElencoPersonalizzato = document.querySelectorAll(".punto-elenco-personalizzato");
if (puntoElencoPersonalizzato.length > 0) {
    import("./_blocks/_puntoElencoPersonalizzato.ts").then(({ default: _puntoElencoPersonalizzato }) => {
        _puntoElencoPersonalizzato.init(puntoElencoPersonalizzato);
    });
}

const canaliCorsi = document.querySelectorAll(".canali-corsi");
if(canaliCorsi.length > 0) {
    import('./_blocks/_canaliCorsi.ts').then(({default: _canaliCorsi}) => {
        _canaliCorsi.init(canaliCorsi);
    });
}

if(!MediaQueries.mobile) {
    const canaliCollegmamento = document.querySelectorAll(".canali-di-collegamento");
    if (canaliCollegmamento .length > 0) {
        import('./_blocks/_canaliDiCollegamento.ts').then(({default: canaliDiCollegamento}) => {
            canaliDiCollegamento.init(canaliCollegmamento);
        });
    }
}


// PAGES
const tabsNav = document.querySelector("nav#tab-nav");
if(tabsNav) {
    import('./_pages/_tabs.ts').then(({default: tabs}) => {
        tabs.init(tabsNav);
    });
}

const modals = document.querySelector("[data-modal]");
if(modals) {
    import('./_components/_modals.ts').then(({default: _modals}) => {
        _modals.init();
    });
}

const tagNav = document.querySelector("nav#tag-nav");
if(tagNav) {
    import('./_pages/_listatoNews.ts').then(({default: listatoNews}) => {
        listatoNews.init(tagNav);
    });
}


// VARIE ED EVENTUALI

// Da attivare solo nel caso in cui nel sito sono presenti fasce
// che usano il pin dello scroll-trigger, assieme a fasce che cambiano di dimensione
// const needsResizeChecker = false;
// if (needsResizeChecker) {
if(!MediaQueries.mobile)
    import("./_core/_resizeChecker.ts").then(({ default: _resizeChecker }) => {
        _resizeChecker.init();
    });
// }

// MENU CONTROLS

const menuBar = document.querySelector<HTMLElement>("#nav-menu #nav-bar");
const menuContent = document.querySelector<HTMLElement>("#nav-menu #nav-page");
const menuButton = menuBar?.querySelector<HTMLElement>("button");
if (menuBar && menuContent && menuButton) {
    import("./_engine/_menu.controls.ts").then(({ default: _menuControls }) => {
        _menuControls.init(menuBar, menuContent, menuButton);
    });
}
